import { render } from "./Day.vue?vue&type=template&id=6dbbc3b1"
import script from "./Day.vue?vue&type=script&lang=js"
export * from "./Day.vue?vue&type=script&lang=js"

import "./Day.vue?vue&type=style&index=0&id=6dbbc3b1&lang=css"

import exportComponent from "/home/forge/christmaswithchrist.me/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__